import { Injectable } from '@angular/core';
import { TranslateService } from '../translate/translate.service';
import { ButtonModel, SimpleModalComponent } from '../../shared/components/simple-modal/simple-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(
    protected _translate: TranslateService,
    protected _modalService: MatDialog,
  ) {
  }

  public openInfoModal(data: {title: string, contentText: string, modalType: string, buttons?: ButtonModel[], showCloseIcon?: boolean, redirectTo?: string}, callback?: (result) => void) {
    const buttons: ButtonModel[] = [{
      title: this._translate.data['ok'],
      type: 'button-secondary',
      action: (activeModal: MatDialogRef<SimpleModalComponent>) => activeModal.close()
    }];
    const modalRef = this._modalService.open(SimpleModalComponent, {hasBackdrop : true});
    modalRef.componentInstance.title = data.title;
    modalRef.componentInstance.contentText = data.contentText;
    modalRef.componentInstance.infoIcon = true;
    modalRef.componentInstance.modalType = data.modalType || 'success';
    modalRef.componentInstance.buttons = data.buttons || buttons;
    modalRef.componentInstance.showCloseIcon = data.showCloseIcon || true;
    modalRef.componentInstance.redirectTo = data?.redirectTo;

    modalRef.afterClosed().subscribe((result) => {
      if (callback instanceof Function) {
        callback(result);
      }
    })
    return modalRef;
  }

  public openWarningModal(msg) {
    if (!msg) { return; }
    return this.openInfoModal({
      title: this._translate.data['modal.warning'],
      contentText: msg,
      modalType: 'error',
    });
  }
}
